import { QueryClient } from '@tanstack/react-query';

import { queryKeys } from 'hooks/queryKeys';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchInterval: false,
      retry: 2,
    },
  },
});

queryClient.setQueryDefaults(queryKeys.currencies.all, {
  staleTime: Infinity,
  cacheTime: Infinity,
});
